import moment from 'moment/moment';
import { LocalError } from 'helpers/errorTypes';
import { OTP_FAILED_ATTEMPTS_LIMIT } from 'modules/Account/constants';
export const getInvalidOTPError = (failedAttempts, method, lockoutEnd = null)=>{
    const failedAttemptsLimit = OTP_FAILED_ATTEMPTS_LIMIT;
    if (failedAttempts < OTP_FAILED_ATTEMPTS_LIMIT) {
        return new LocalError({
            code: 'InvalidOTPEntry',
            params: {
                failedAttempts,
                method,
                failedAttemptsLimit
            }
        });
    }
    const nowTimestamp = Math.floor(Date.now() / 1000);
    let lockDuration = Math.max(lockoutEnd - nowTimestamp, 0);
    let lockUnit;
    if (lockDuration < 60) {
        lockUnit = 's';
        lockDuration = Math.round(lockDuration / 10) * 10;
    } else if (lockDuration >= 60 && lockDuration < 3600) {
        lockUnit = 'm';
        lockDuration = Math.round(lockDuration / 60);
    } else {
        lockUnit = 'h';
        lockDuration = Math.round(lockDuration / 3600);
    }
    return new LocalError({
        code: 'InvalidOTPEntryLock',
        params: {
            lockDuration,
            lockUnit,
            method,
            lockoutEnd
        }
    });
};
export const getLockDuration = (durationSeconds)=>{
    const duration = moment.duration(durationSeconds, 'seconds');
    if (durationSeconds < 60) {
        return {
            duration: duration.seconds(),
            unit: 's'
        };
    }
    if (durationSeconds >= 60 && durationSeconds < 3600) {
        return {
            duration: duration.minutes(),
            unit: 'm'
        };
    }
    return {
        duration: duration.hours(),
        unit: 'h'
    };
};
